// extracted by mini-css-extract-plugin
export var measureBox = "_bb-0";